import React from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";
import Input, { PasswordInput } from "../Input";

import Navbar from "../Navbar";
import { Link } from "react-router-dom";
import ForwardArrow from "../../Assets/forward-arrow.svg";

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: { value: "", warning: { msg: "", class: "" } },
      confirmPassword: { value: "", warning: { msg: "", class: "" } },
    };
  }
  handlePasswordChange(e) {
    var tempState = { ...this.state.password };
    tempState.value = e.target.value;
    if (tempState.value.length === 0) {
      tempState.warning.msg = "";
      tempState.warning.class = "";
    } else if (tempState.value.length < 3) {
      tempState.warning.msg = "Weak";
      tempState.warning.class = "red";
    } else if (tempState.value.length < 8) {
      tempState.warning.msg = "Medium";
      tempState.warning.class = "yellow";
    } else if (tempState.value.length < 13) {
      tempState.warning.msg = "Strong";
      tempState.warning.class = "blue";
    } else {
      tempState.warning.msg = "Very Strong";
      tempState.warning.class = "green";
    }
    this.setState({ password: tempState });
  }

  handleConfirmPasswordChange(e) {
    var tempState = { ...this.state.confirmPassword };
    tempState.value = e.target.value;

    if (tempState.value.length === 0) {
      tempState.warning.msg = "";
      tempState.warning.class = "";
    } else if (this.state.password.value !== tempState.value) {
      tempState.warning.msg = "Password Mismatch";
      tempState.warning.class = "red";
    } else {
      tempState.warning.msg = "";
      tempState.warning.class = "";
    }
    this.setState({ confirmPassword: tempState });
  }

  render() {
    return (
      <React.Fragment>
        <Navbar showSignup={true} />
        <Container fluid className="main-container">
          <Modal show={true} centered contentClassName="login-modal p-2">
            <Modal.Body className="pb-0">
              <Container>
                <Row>
                  <Col xs={10} md={11} className="px-0">
                    <h4 style={{ color: "#FFFFFF" }}>Reset you password</h4>
                    <h1
                      style={{
                        fontFamily: "JioType-Medium",
                        color: "#7B7B7B",
                        fontSize: "14px",
                      }}
                      className="sub-title"
                    >
                      Your new password must be different from previous used
                      passwords.
                    </h1>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={12} className="px-0">
                    <Input
                      required
                      warning={this.state.password.warning}
                                                value={this.state.password.value}
                                                onChange={(e) => this.handlePasswordChange(e)}
                      label="Enter new password"
                      type="password"
                      name="password"
                      style={{ marginBottom: "-5px" }}
                    />

                    <PasswordInput
                      required
                      label="Confirm new password"
                      type="password"
                      name="confirm password"
                      warning={this.state.confirmPassword.warning}
                                                value={this.state.confirmPassword.value}
                                                onChange={(e) => this.handleConfirmPasswordChange(e)}
                                                style={{ marginBottom: "-5px" }}
                    />

                    <Link to="/reset-success">
                      <p className="link justify-content-center d-flex">
                        Reset Password
                        <Link to="/reset-success">
                          <img
                            alt=""
                            className="m-1"
                            src={ForwardArrow}
                            height="12"
                            width="13"
                            marginTop="-2px"
                          />
                        </Link>
                      </p>
                    </Link>
                  </Col>
                </Row>
              </Container>
            </Modal.Body>
          </Modal>
        </Container>
      </React.Fragment>
    );
  }
}

export default ResetPassword;
